import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { Window, Dialog, ConfirmDialog, EmptyState, Loading, StatusBadge } from "../../components/VB";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";

export default function Absensi() {
  const [items, setItems] = useState([]);
  const [emps, setEmps] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const today = new Date().toISOString().slice(0, 10);
  const [form, setForm] = useState({ tanggal: today, employee_id: "", shift_id: "", status: "Hadir", jam_masuk: "", jam_pulang: "", catatan: "" });
  const [del, setDel] = useState(null);
  const [filterEmp, setFilterEmp] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterStart, setFilterStart] = useState("");
  const [filterEnd, setFilterEnd] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filterEmp) params.employee_id = filterEmp;
      if (filterStatus) params.status = filterStatus;
      if (filterStart) params.tanggal_mulai = filterStart;
      if (filterEnd) params.tanggal_akhir = filterEnd;
      const [a, e, s] = await Promise.all([
        api.get("/absensi", { params }), api.get("/employees"), api.get("/shifts")
      ]);
      setItems(a.data); setEmps(e.data); setShifts(s.data);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setLoading(false);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filterEmp, filterStatus, filterStart, filterEnd]);

  const reset = () => setForm({ tanggal: today, employee_id: "", shift_id: "", status: "Hadir", jam_masuk: "", jam_pulang: "", catatan: "" });
  const openEdit = (it) => { setForm({ ...it }); setEditId(it.id); setOpen(true); };
  const openCreate = () => { reset(); setEditId(null); setOpen(true); };

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (editId) await api.put(`/absensi/${editId}`, form);
      else await api.post("/absensi", form);
      toast.success("Absensi tersimpan"); setOpen(false); load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const doDelete = async () => {
    try { await api.delete(`/absensi/${del.id}`); toast.success("Dihapus"); setDel(null); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  const empName = (id) => emps.find((e) => e.id === id)?.nama_lengkap || "-";
  const shiftName = (id) => shifts.find((e) => e.id === id)?.nama || "-";

  return (
    <Window
      title="Management Absensi Harian"
      actions={<button className="vb-btn" onClick={openCreate} data-testid="add-absensi"><Plus className="w-3 h-3 inline mr-1" />Input Absensi</button>}
    >
      <div style={{ display: "flex", gap: 6, marginBottom: 10, flexWrap: "wrap" }}>
        <select className="vb-select" style={{ width: 200 }} value={filterEmp} onChange={(e) => setFilterEmp(e.target.value)} data-testid="filter-emp">
          <option value="">Semua Karyawan</option>
          {emps.map((e) => <option key={e.id} value={e.id}>{e.nama_lengkap}</option>)}
        </select>
        <select className="vb-select" style={{ width: 150 }} value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)} data-testid="filter-abs-status">
          <option value="">Semua Status</option>
          <option>Hadir</option><option>Tidak Hadir</option><option>Izin</option><option>Sakit</option><option>Terlambat</option><option>Pulang Cepat</option>
        </select>
        <input type="date" className="vb-input" style={{ width: 150 }} value={filterStart} onChange={(e) => setFilterStart(e.target.value)} data-testid="filter-start" />
        <input type="date" className="vb-input" style={{ width: 150 }} value={filterEnd} onChange={(e) => setFilterEnd(e.target.value)} data-testid="filter-end" />
      </div>

      {loading ? <Loading /> : items.length === 0 ? <EmptyState /> : (
        <div style={{ overflowX: "auto" }}>
          <table className="vb-table">
            <thead><tr><th>Tanggal</th><th>Karyawan</th><th>Shift</th><th>Status</th><th>Masuk</th><th>Pulang</th><th>Catatan</th><th>Aksi</th></tr></thead>
            <tbody>
              {items.map((it) => (
                <tr key={it.id}>
                  <td>{it.tanggal}</td>
                  <td>{empName(it.employee_id)}</td>
                  <td>{shiftName(it.shift_id)}</td>
                  <td><StatusBadge status={it.status} /></td>
                  <td>{it.jam_masuk || "-"}</td>
                  <td>{it.jam_pulang || "-"}</td>
                  <td>{it.catatan || "-"}</td>
                  <td>
                    <button className="vb-btn" style={{ padding: "2px 6px", marginRight: 4 }} onClick={() => openEdit(it)} data-testid={`abs-edit-${it.id}`}><Pencil className="w-3 h-3" /></button>
                    <button className="vb-btn-danger" style={{ padding: "2px 6px" }} onClick={() => setDel(it)} data-testid={`abs-del-${it.id}`}><Trash2 className="w-3 h-3" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <Dialog open={open} onClose={() => setOpen(false)} title={editId ? "Edit Absensi" : "Input Absensi"}
        footer={<><button className="vb-btn" onClick={() => setOpen(false)}>Batal</button><button className="vb-btn-primary" onClick={submit} data-testid="abs-save">Simpan</button></>}>
        <form onSubmit={submit}>
          <div className="vb-form-row"><label className="vb-label">Tanggal*</label>
            <input type="date" className="vb-input" value={form.tanggal} onChange={(e) => setForm({ ...form, tanggal: e.target.value })} required data-testid="abs-tanggal" /></div>
          <div className="vb-form-row"><label className="vb-label">Karyawan*</label>
            <select className="vb-select" value={form.employee_id} onChange={(e) => setForm({ ...form, employee_id: e.target.value })} required data-testid="abs-employee">
              <option value="">- pilih -</option>
              {emps.map((e) => <option key={e.id} value={e.id}>{e.nama_lengkap}</option>)}
            </select></div>
          <div className="vb-form-row"><label className="vb-label">Shift</label>
            <select className="vb-select" value={form.shift_id} onChange={(e) => setForm({ ...form, shift_id: e.target.value })} data-testid="abs-shift">
              <option value="">- pilih -</option>
              {shifts.map((s) => <option key={s.id} value={s.id}>{s.nama} ({s.jam_masuk}-{s.jam_pulang})</option>)}
            </select></div>
          <div className="vb-form-row"><label className="vb-label">Status*</label>
            <select className="vb-select" value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })} data-testid="abs-status">
              <option>Hadir</option><option>Tidak Hadir</option><option>Izin</option><option>Sakit</option><option>Terlambat</option><option>Pulang Cepat</option>
            </select></div>
          <div className="vb-form-row"><label className="vb-label">Jam Masuk</label>
            <input type="time" className="vb-input" value={form.jam_masuk} onChange={(e) => setForm({ ...form, jam_masuk: e.target.value })} data-testid="abs-masuk" /></div>
          <div className="vb-form-row"><label className="vb-label">Jam Pulang</label>
            <input type="time" className="vb-input" value={form.jam_pulang} onChange={(e) => setForm({ ...form, jam_pulang: e.target.value })} data-testid="abs-pulang" /></div>
          <div className="vb-form-row"><label className="vb-label">Catatan</label>
            <textarea className="vb-textarea" rows={2} value={form.catatan} onChange={(e) => setForm({ ...form, catatan: e.target.value })} /></div>
        </form>
      </Dialog>

      <ConfirmDialog open={!!del} onClose={() => setDel(null)} onConfirm={doDelete} message="Yakin hapus absensi ini?" />
    </Window>
  );
}
